import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {UploadDokumenComponent} from "./upload-dokumen.component";

const routes: Routes = [
  {
    path: 'upload-dokumen',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: UploadDokumenComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UploadDokumenRoutingModule { }
